import React, { useEffect } from "react";
import curveLine from "../assets/curveLine.png";
import stars from "../assets/Stars.png";
import testimonial_person_1 from "../assets/testimonial_person_1.png";
import testimonial_person_2 from "../assets/testimonial_person_2.png";
import testimonial_person_3 from "../assets/testimonial_person_3.png";
import AOS from 'aos';
import 'aos/dist/aos.css';
const TestimonialSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, [])
  return (
    <div id="testimonial" className="flex flex-col rounded-none">
      <div className="flex flex-col justify-center items-center xl:px-20 py-14 w-full bg-[#E5E2EC?] max-md:px-5 max-md:max-w-full">
        <div className="flex flex-col items-center w-full max-w-[1135px] max-md:max-w-full">
          <div className="text-4xl text-center leading-none text-themeColor font-yeseva pb-1">
            Testimonial
          </div>
          <div className=" text-4xl leading-none text-[#0B0B19] max-md:max-w-full font-yeseva text-center">
            What Our <span className="text-secondColor">Client</span> Say's
          </div>
          <img
            loading="lazy"
            src={curveLine}
            className="object-contain mt-6 w-32 max-w-full aspect-[15.87]"
            alt="Decorative element"
          />
          <div className="w-[90%] xl:w-[85%] m-auto flex flex-wrap gap-8  justify-center">
            <div data-aos="fade-up" data-aos-duration="1000" className="h-auto xs:h-[300px] mt-10 md:mt-12 lg:mt-28 flex flex-col md:max-w-[40%] lg:w-[31%] shadow-custom-dark pl-5 py-5 pr-14 text-justify rounded-2xl bg-[#FFFBFB]">
              <div className="mb-6">
                <img className="w-32" src={stars} alt="" />
              </div>
              <div className="font-yeseva text-header mb-3 leading-5">
                A Life-Changing <br />
                Experience
              </div>
              <div className="text-[12px] font-poppins leading-4">
                My Wali provided a supportive environment where my family and I
                could find a truly compatible match. The process was respectful
                and aligned with our values.
              </div>
              <hr className="bg-themeColor w-24 h-[1.85px] my-3" />
              <div className="flex gap-5 font-semibold items-center ">
                <img className="w-11" src={testimonial_person_1} alt="" />
                <div>
                <h1 className="text-sm font-montserrat text-black">
                     —Ahmed Khan
                  </h1>
                  <div className="text-[7px] font-poppins">Family Member</div>
                </div>
              </div>
            </div>
            <div data-aos="fade-up" data-aos-duration="1500" className="h-auto xs:h-[290px] mt-0 md:mt-12 flex flex-col md:max-w-[40%] lg:w-[31%] shadow-custom-dark pl-5 py-5 pr-14 text-justify rounded-2xl gradientPurple">
              <div className="mb-6">
                <img className="w-32" src={stars} alt="" />
              </div>
              <div className="font-yeseva text-[#D0C235] mb-3 leading-5">
              Guidance and <br />
              Support
              </div>
              <div className="text-[12px] font-poppins leading-4 text-white">
              The involvement of guardians throughout the process made all the difference. I felt guided and supported every step of the way.
              </div>
              <hr className="bg-white w-24 h-[1.85px] my-5" />
              <div className="flex gap-5 items-center font-light">
                <img className="w-11" src={testimonial_person_2} alt="" />
                <div>
                  <h1 className="text-sm font-montserrat text-white">
                     —Ayesha Rahman
                  </h1>
                  <div className="text-[7px] font-poppins text-white">Recent User</div>
                </div>
              </div>
            </div>
            <div data-aos="fade-up" data-aos-duration="1000" className="h-auto xs:h-[300px] mt-0 md:mt-12 lg:mt-28 flex flex-col md:max-w-[40%] lg:w-[31%] shadow-custom-dark pl-5 py-5 pr-14 text-justify rounded-2xl bg-[#FFFBFB]">
              <div className="mb-6">
                <img className="w-32" src={stars} alt="" />
              </div>
              <div className="font-yeseva text-header mb-3 leading-5">
              Connections and <br />
              Respect
              </div>
              <div className="text-[12px] font-poppins leading-4">
              I appreciated the focus on halal interactions and genuine connections. My Wali exceeded my expectations in finding a meaningful partner.
              </div>
              <hr className="bg-themeColor w-24 h-[1.85px] my-3" />
              <div className="flex gap-5 font-semibold items-center">
                <img className="w-11" src={testimonial_person_3} alt="" />
                <div>
                <h1 className="text-sm font-montserrat text-black">
                — Fatima Ali
                  </h1>
                  <div className="text-[7px] font-poppins">Family Member</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSection;
